import { render } from "./SoleTraderForm.vue?vue&type=template&id=64ceb3f6&scoped=true"
import script from "./SoleTraderForm.vue?vue&type=script&lang=js"
export * from "./SoleTraderForm.vue?vue&type=script&lang=js"

import "./SoleTraderForm.vue?vue&type=style&index=0&id=64ceb3f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ceb3f6"]])

export default __exports__